import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@urc-ui/store/types';
import { Filter, Sort } from '@urc-ui/store/api/types';

interface AnalysisTableState {
  readonly sortColumn: Sort | null;
  readonly pageSize: number;
  readonly filters: Filter[];
  readonly visibleColumns: string[];
  readonly searchTerm: string;
}

const initialState: AnalysisTableState = {
  sortColumn: { columnName: 'createdAt', order: 'desc' },
  pageSize: 50,
  filters: [],
  visibleColumns: [],
  searchTerm: ''
};

export const analysisTableSlice = createSlice({
  name: 'analysisTableSlice',
  initialState,
  reducers: {
    setAnalysisTableSortColumn: (state, action: PayloadAction<Sort | null>) => {
      state.sortColumn = action.payload;
    },
    setAnalysisTablePageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setAnalysisTableFilters: (state, action: PayloadAction<Filter[]>) => {
      state.filters = action.payload;
    },
    setAnalysisTableVisibleColumns: (state, action: PayloadAction<string[]>) => {
      state.visibleColumns = action.payload;
    },
    setAnalysisTableSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    }
  }
});

export const {
  setAnalysisTableSortColumn,
  setAnalysisTablePageSize,
  setAnalysisTableFilters,
  setAnalysisTableVisibleColumns,
  setAnalysisTableSearchTerm
} = analysisTableSlice.actions;

export const selectAnalysisTableSortColumn = (state: RootState) => state.analysisTable.sortColumn;
export const selectAnalysisTablePageSize = (state: RootState) => state.analysisTable.pageSize;
export const selectAnalysisTableFilters = (state: RootState) => state.analysisTable.filters;
export const selectAnalysisTableVisibleColumns = (state: RootState) => state.analysisTable.visibleColumns;
export const selectAnalysisTableSearchTerm = (state: RootState) => state.analysisTable.searchTerm;

export default analysisTableSlice.reducer;
